<template>
  <div class="w-100" style="min-height:38px;text-align:center; margin-bottom: 1rem;">
    <FlexTable class="daily-consumption-table">
      <div class="flex-th table-title">Describa lo que come en un día</div>
      <div class="flex-trow flex-trow-header">
        <div class="flex-th flex-thd">
          Incluye todos tus tiempos de comida desde que te levantas hasta que te duermes
        </div>
      </div>
      <div class="flex-trow flex-trow-header">
        <div class="flex-th">Comida</div>
        <div class="flex-th">Hora</div>
        <div class="flex-th details-th">Ingredientes / Detalles</div>
      </div>
      <div class="flex-trow flex-trow-content">
        <div class="flex-td">
          Ej: Desayuno
        </div>
        <div class="flex-td">
          08:00
        </div>
        <div class="flex-td details-td">
          Leche semidescremada + 1 marraqueta con jamón
        </div>
      </div>
      <div 
        v-for="(row, index) in formData"
        :key="index"
        class="flex-trow flex-trow-content"
      >
        <div v-show="!disabled" class="remove-meal" @click="removeRow(index)">
          <IconCross />
        </div>
        <div class="flex-td editable-cell">
          <EditableCellSelect
            v-model="row.meal"
            :units="optionsMeals"
            :disabled="disabled"
          />
        </div>
        <div class="flex-td editable-cell">
          <EditableCellInput
            inputType="time"
            v-model="row.time" 
            :disabled="disabled"
            :state="$v.formData.$each[index].time.$invalid ? false : null "
          />
        </div>
        <div class="flex-td details-td editable-cell">
          <EditableCellInput 
            v-model="row.details"
            :is-textarea="true" 
            :disabled="disabled"
            :state="$v.formData.$each[index].details.$invalid ? false : null "
          />
        </div>
      </div>
    </FlexTable>
    <b-button-group>   
      <b-button
        v-on:click="addRow"
        :disabled="disabled"
      >Agregar comida
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
import FlexTable from "./base/FlexTable";
import EditableCellInput from "../EditableCellInput";
import EditableCellSelect from '../EditableCellSelect';
import IconCross from "../icon/IconCross";
import { maxLength } from 'vuelidate/lib/validators'

export default {
  name: "DailyConsumptionTable",
  components: { EditableCellSelect, EditableCellInput, FlexTable, IconCross },
  props: {
    value: Array,
    optionsMeals: Array,
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      formData: this.value,
    }
  },
  validations: {
    formData: {
      $each: {
        time: {
          isTime (value) {
            let isNull = value === undefined || value === null
            return isNull
              || this.$moment(value, "HH:mm:ss", true).isValid()
              || this.$moment(value, "HH:mm", true).isValid()
          }
        },
        details: {
          maxLength: maxLength(300)
        }
      }
    }
  },
  methods: {
    addRow: function() {
      this.formData.push(
        {
        meal: undefined,
        time: undefined,
        details: ""
        }
      );
      this.$emit('input', this.formData);
    },
    removeRow: function(index) {
      this.formData.splice(index, 1)
      this.$emit('input', this.formData)
    },
    loadData(data) {
      this.formData = data;
    },
    validate() {
      this.$v.formData.$touch();
      var isValid = !this.$v.formData.$invalid
      this.$emit('on-validate', isValid)
      return isValid
    }
  },
}
</script>

<style scoped lang="scss">
$daily-consumption-table-base-color: $dark-blue;
$daily-consumption-table-title-bg-color: $daily-consumption-table-base-color;
$daily-consumption-table-title-color: $white;
$daily-consumption-table-header-bg-color: rgba($daily-consumption-table-base-color, 0.1);
$daily-consumption-table-header-color: darken($daily-consumption-table-base-color, 25);
$daily-consumption-table-desc-bg-color: rgba($daily-consumption-table-base-color, 0.3);
$daily-consumption-table-desc-color: darken($daily-consumption-table-base-color, 20);

.daily-consumption-table {
  overflow-x: auto;
  padding: 4px;
  width: 100%;
  flex-direction: column;
}

.flex-th.table-title {
  background-color: $daily-consumption-table-title-bg-color;
  color: white;
  position: sticky;
  left: 0;
  width: 100%;
}

.flex-th {
  background-color: $daily-consumption-table-header-bg-color;
  color: $daily-consumption-table-header-color;
  padding: 0.25rem;
}

.flex-thd {
  background-color: $daily-consumption-table-desc-bg-color;
  color: $daily-consumption-table-desc-color;
  padding: 0.25rem;
}

.flex-trow-header > .flex-th, .flex-trow-content > .flex-td {
  flex: 1 0 6rem;
  min-width: 6rem;
}

.flex-trow-header > .flex-th.num-cell, .flex-trow-content > .flex-td.num-cell {
  flex: 1 0 6rem;
  min-width: 6rem;
}

.flex-trow-header > .flex-th.details-th, .flex-trow-content > .flex-td.details-td {
  flex: 1 0 27rem;
  min-width: 12rem;
}

.flex-trow .remove-meal {
  display: none;
  position: absolute;
  margin: -0.5px;
  height: 4rem;
  align-items: center;
  width: 2rem;
  justify-content: center;
  color: inherit;

  & svg {
    width: 1rem;
    margin-top: 0.1rem;
    opacity: 0.5;
  }

  &:after {
    content: "";
    display: block;
    background-color: currentColor;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.1;
  }
}

.flex-trow:hover .remove-meal {
  display: flex;
  cursor: pointer;
}

// Hide incremental arrows
/* Chrome, Safari, Edge, Opera */
.editable-cell input::-webkit-outer-spin-button,
.editable-cell input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.editable-cell input[type=number] {
  -moz-appearance: textfield;
}
</style>